import type { ActivityEntityConfig, RawActivity } from "./types";

export type DocumentActivityType =
  | "upload"
  | "update"
  | "download"
  | "delete"
  | "tag"
  | "summary"
  | "failure"
  | "version";

export const documentActivityConfig: ActivityEntityConfig<DocumentActivityType> =
  {
    eventTypeCategories: {
      upload: "status",
      update: "content",
      download: "content",
      delete: "status",
      tag: "content",
      summary: "system",
      failure: "system",
      version: "content",
    },
    defaultCategory: "content",
    eventTypeLabels: {
      upload: "Document uploaded",
      update: "Document updated",
      download: "Document downloaded",
      delete: "Document deleted",
      tag: (raw: RawActivity<DocumentActivityType>) => {
        const tagsAdded = raw.metadata?.tagsAdded;
        if (Array.isArray(tagsAdded) && tagsAdded.length > 0) {
          return `Auto-tagging completed: ${tagsAdded.length} tag(s) added`;
        }
        return "Auto-tagging completed";
      },
      summary: "Summary generated",
      failure: (raw: RawActivity<DocumentActivityType>) => {
        const reason = raw.metadata?.reason ?? "Unknown error";
        return `Failed: ${reason}`;
      },
      version: "Version created",
    },
    fieldLabels: {},
    fieldTitleLabels: {},
    metadataSkipKeys: new Set([
      "changes",
      "success",
      "data",
      "error",
      "requestId",
      "tagsAdded",
      "reason",
      "errorCode",
    ]),
    systemActorName: "System",
  };
